import React from 'react';
import { VStack, Input, Button } from '@chakra-ui/react';
import { Field } from '@/components/ui/field';

interface ChargeInputContentProps {
  chargeCode: string;
  onChargeCodeChange: (code: string) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const ChargeInputContent: React.FC<ChargeInputContentProps> = ({
  chargeCode,
  onChargeCodeChange,
  onSubmit,
  isLoading = false,
}) => {
  return (
    <VStack gap={6} align="stretch" pb={4}>
      <Field label="チャージコード">
        <Input
          placeholder="チャージコードを入力"
          value={chargeCode}
          onChange={e => onChargeCodeChange(e.target.value)}
          size="lg"
          disabled={isLoading}
        />
      </Field>
      <Button
        colorPalette="teal"
        size="lg"
        w="full"
        onClick={onSubmit}
        disabled={!chargeCode || isLoading}
        loading={isLoading}
      >
        チャージする
      </Button>
    </VStack>
  );
};
